import { MasterFixture } from "./all";
import type { DividersSetByHand } from "@CommonTypes/backend/PspRules";
import type { DividerRuleErrorCode } from "@CommonUtils/pog/dividerPolicyValidation";

export const RoutePutInputsMasterFixtures_masterFixtureId_ =
  "/inputs/master-fixtures/:masterFixtureId";

export type ParamsPutInputsMasterFixtures_masterFixtureId_ = {
  masterFixtureId: string;
};

export type PayloadPutInputsMasterFixtures_masterFixtureId_ = {
  maxShelfHeight: number;
  maxProductHead: number;
  /** Absent leaves the override as it is; null clears it. */
  dividersSetByHand?: DividersSetByHand | null;
  /**
   * Spring loader depth for this fixture row, x100 like `shelf_depth`. Absent
   * leaves it as it is; null clears it ("Not set": follow the rule); 0 says
   * the shelf never has one ("None"); > 0 says it always has one this deep.
   */
  loaderDepth?: number | null;
  /** Absent preserves the physical shelf permission; zero disables it. */
  maxFrontOverhang?: number;
};

export type ResponsePutInputsMasterFixtures_masterFixtureId_ = MasterFixture;

/** The 400 for a refused `loaderDepth`; the frontend words `code` and `params`. */
export interface ErrorPutInputsMasterFixtures_masterFixtureId_ {
  message: string;
  code?: DividerRuleErrorCode;
  field?: string;
  params?: { depth: number };
}
